export default __webpack_public_path__ + "static/media/176.1c271cee.png";